import { useState } from "react";
import bgImageForForm from "../assets/product-5c64122098568.[1090].jpeg";

const FormComponent = () => {

  const [data, setData] = useState({
    to: ``,
    subject: ``,
    body: ``,
    phone: ``,
    name: ``,
  })


  const sendEmail = e => {
    console.log(e)
    console.log(data)
    sendEmail({ ...data })
    data({
      to: ``,
      subject: ``,
      body: ``,
      phone: ``,
      name: ``,
    })
  }

  return (
    <div className="my-[5rem] animate__animated animate__fadeInUpBig animate__delay-200ms">
      <div
        className="lg:h-[550px] lg:w-[90%] md:w-[90%] sm:w-full sm:m-0 lg:m-auto md:m-auto md:h-[600px] sm:h-[auto] flex justify-evenly lg:flex-row md:flex-row sm:flex-col py-20  flex-wrap"
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8)) , url(${bgImageForForm})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundAttachment: 'fixed',
          objectFit: "cover",
        }}
      >

        <form onSubmit={sendEmail} className="px-2">
          <div className="text-[25px] font-bold mb-5 text-[#ffa809]">
            <p>Devenez bénévole</p>
          </div>
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4 mb-3">
            <input
              className="bg-opacity-5 bg-white   p-2 text-white border-solid border-2 border-[#ffa809]"
              type="text"
              placeholder="Name"
              name="name"
              required
              onChange={(e) => {
                setData(d => {
                  return { ...d, name: e.target.value }
                })
              }}
              value={data.name}
            ></input>
            <input
              className="bg-opacity-5 bg-white p-2   text-white border-solid border-2 border-[#ffa809]"
              type="text"
              placeholder="Email"
              name="to"
              onChange={(e) => {
                setData(d => {
                  return { ...d, to: e.target.value }
                })
              }}
              value={data.to}
              required
            ></input>
          </div>
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-4 mb-3">
            <input
              className="bg-opacity-5 bg-white   text-white  p-2 border-solid border-2 border-[#ffa809]"
              type="text"
              placeholder="Phone"
              name="phone"
              required
              onChange={(e) => {
                setData(d => {
                  return { ...d, phone: e.target.value }
                })
              }}
              value={data.phone}
            ></input>

            <input
              className="bg-opacity-5 bg-white  text-white p-2 border-solid border-2 border-[#ffa809]"
              type="text"
              placeholder="Subject"
              required
              name="subject"
              onChange={(e) => {
                setData(d => {
                  return { ...d, subject: e.target.value }
                })
              }}
              value={data.subject}
            ></input>
          </div>

          <div className="grid lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1">
            <textarea
              rows={4.5}
              className="bg-opacity-5  my-2  text-white bg-white p-2 border-solid border-2 border-[#ffa809]"
              maxLength={255}
              placeholder="Detail..."
              name="body"
              onChange={(e) => {
                setData(d => {
                  return { ...d, body: e.target.value }
                })
              }}
              value={data.body}
            ></textarea>
          </div>
          <div className="bg-[#ffa809] w-24  h-10 flex items-center justify-center mt-10 text-white">
            <button type="submit">Submit</button>
          </div>
        </form>

        <div className="text-white px-2 py-2   my-4">
          <div className="flex bottom-2 gap-2">
            <div className="my-2 flex items-center justify-center border-2 bg-opacity-5 bg-white border-[#ffa809] lg:w-[180px] md:w-[160px] sm:w-[160px]  h-40 mt-6 ">
              <div>
                <p className="text-center font-bold text-[30px]">50K</p>
                <p className="text-center">Work Done</p>
              </div>
            </div>
            <div className="my-2 flex items-center justify-center border-2 bg-opacity-5 bg-white border-[#ffa809] lg:w-[180px] md:w-[160px] sm:w-[160px]  h-40">
              <div>
                <p className="text-center font-bold text-[30px]">50K</p>
                <p className="text-center">Work Done</p>
              </div>
            </div>
          </div>
          <div className="flex justify-center align-middle gap-2">
            <div className="my-2 flex items-center justify-center border-2 bg-opacity-5 bg-white border-[#ffa809] lg:w-[180px] md:w-[160px] sm:w-[160px]  h-40 mt-6 ">
              <div>
                <p className="text-center font-bold text-[30px]">50K</p>
                <p className="text-center">Work Done</p>
              </div>
            </div>
            <div className="my-2 flex items-center justify-center border-2 bg-opacity-5 bg-white border-[#ffa809] lg:w-[180px] md:w-[160px] sm:w-[160px]   h-40">
              <div>
                <p className="text-center font-bold text-[30px]">50K</p>
                <p className="text-center">Work Done</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
export default FormComponent;
